"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.size = void 0;
exports.size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '430px',
    tablet: '768px',
    laptop: '1024px',
    laptopM: '1199px',
    laptopL: '1440px',
    desktop: '2560px'
};
const device = {
    mobileS: `(max-width: ${exports.size.mobileS})`,
    mobileM: `(max-width: ${exports.size.mobileM})`,
    mobileL: `(max-width: ${exports.size.mobileL})`,
    tablet: `(max-width: ${exports.size.tablet})`,
    laptop: `(max-width: ${exports.size.laptop})`,
    laptopM: `(max-width: ${exports.size.laptopM})`,
    laptopL: `(max-width: ${exports.size.laptopL})`,
    desktop: `(max-width: ${exports.size.desktop})`,
    desktopL: `(max-width: ${exports.size.desktop})`
};
exports.default = device;
//# sourceMappingURL=Breakpoints.js.map